'use client';

import { BuyOnlineModal } from '@checkout/Components/BuyOnlineModal/BuyonlineModal';
import { Typography } from '@gds/Typography/Typography';
import { useModal } from '@modal/Hooks/UseModal';
import { KenticoImage } from '@shared-components/KenticoImage/KenticoImage';

import type { BuyOnlineUspsProps } from './BuyOnlineUspsItems.entity';

import styles from '../UspsItems/UspsItems.module.css';

export const BuyOnlineUspsItems = ({
  strings,
  buyOnlineUsps,
  buyOnlineModalData,
  children: RatingComponent,
}: BuyOnlineUspsProps) => {
  const { openModal } = useModal();

  const openBuyOnlineUspsModal = () => {
    const modalComponent = <BuyOnlineModal buyOnlineModalData={buyOnlineModalData} />;

    openModal(modalComponent, {
      header: strings.buyOnlineHeader,
      modalClassName: styles.modalContainer,
      modalBodyClassName: styles.modalBody,
    });
  };

  return (
    <div className={styles.uspsPadding}>
      <div className={styles.uspsWrapper}>
        <Typography variant="subheading1" className={styles.title}>
          {buyOnlineUsps.heading}
          {buyOnlineUsps.description && <span> {buyOnlineUsps.description}</span>}
        </Typography>

        <ul className={styles.usps}>
          {buyOnlineUsps.uspItems.map(uspItem => {
            const { image, title, description } = uspItem;

            return (
              <li className={styles.uspItem} key={description}>
                <div className={styles.uspIcon}>
                  <KenticoImage
                    src={image[0]}
                    alt={title}
                    fill
                    style={{ objectFit: 'contain' }}
                    sizes="(max-width: 768px) 20vw, (max-width: 1200px) 33vw"
                  />
                </div>
                <Typography variant="subheading3">{description}</Typography>
              </li>
            );
          })}
        </ul>
        <Typography
          className={styles.linkModal}
          onClick={openBuyOnlineUspsModal}
          variant="buttonLink2"
        >
          {buyOnlineUsps.uspLink[0]?.ctaText}
        </Typography>

        {RatingComponent}
      </div>
    </div>
  );
};
